import ValidationType from '../ValidationType';
import { numberIsLessThan, numbersAreEqual } from "../../util";

class LessThanField extends ValidationType {

  get comparesField() {
    return true
  }

  validateResponseWithValidation(fieldResponse, validation, formResponse = null) {
    let errors = [];
    if (!fieldResponse.isEmpty) {
      if (validation.target) {
        const targetFieldResponse = formResponse
          ? fieldResponse.recapResponse.getFieldResponseForFieldInstanceIdAndFormResponseId(validation.target.id, formResponse.id)
          : fieldResponse.recapResponse.getFieldResponseForFieldInstanceId(validation.target.id);
        const current = fieldResponse.currentValue;
        const compare = targetFieldResponse.currentValue;
        if (!numberIsLessThan(current, compare) || numbersAreEqual(current, compare)) {
          errors.push(this.createValidationError({
            fieldResponse: fieldResponse,
            key: 'ERROR_LESS_THAN_SPECIFIED_FIELD',
            values: { value: targetFieldResponse.currentValue },
            message: `Value should be less than '${targetFieldResponse.currentValue}'`,
          }));
        }
      } else {
        console.warn("No target present for validation", validation);
      }
    }
    return errors;
  }
}

export default LessThanField;

